import { createFileRoute, redirect } from "@tanstack/react-router";
import { WINDOWS, type WindowDays } from "@/routes/_authenticated/_crm/crm/-components/format";

/* Retired: the CRM dashboard at /crm is this page now. Old links and bookmarks land there. */
export const Route = createFileRoute("/_authenticated/_crm/crm/analytics/")({
  validateSearch: (search: Record<string, unknown>): { days?: WindowDays } => ({
    days: WINDOWS.find((days) => days === Number(search.days)),
  }),
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/crm", search, replace: true });
  },
});
